import socket from './socket';

const getContentTypeTemplates = (headers) =>
  socket.get('/point-system-templates', undefined, headers);

const createContentTypeTemplate = (data, headers) =>
  socket.post('/point-system-templates', data, headers);

const updateContentTypeTemplate = (id, data, headers) =>
  socket.patch(`/point-system-templates/${id}`, data, headers);

const deleteContentTypeTemplate = (id, headers) =>
  socket.delete(`/point-system-templates/${id}`, undefined, headers);

const getContentTypes = (pointSystemId, headers) =>
  socket.get(`/point-systems/${pointSystemId}/content-types`, undefined, headers);

const createContentType = (pointSystemId, data, headers) =>
  socket.post(`/point-systems/${pointSystemId}/content-types`, data, headers);

const updateContentType = (id, data, headers) =>
  socket.patch(`/content-types/${id}`, data, headers);

const deleteContentType = (id, headers) =>
  socket.delete(`/content-types/${id}`, undefined, headers);

const applyContentTypeTemplate = (pointSystemId, templatePointSystemId, headers) =>
  socket.post(
    `/point-systems/${pointSystemId}/apply-template`,
    { templatePointSystemId },
    headers,
  );

export default {
  getContentTypeTemplates,
  createContentTypeTemplate,
  updateContentTypeTemplate,
  deleteContentTypeTemplate,
  getContentTypes,
  createContentType,
  updateContentType,
  deleteContentType,
  applyContentTypeTemplate,
};
